import React, { useEffect, useState } from "react";
import Header from "../header/Header";

function Balanceco() {
  const [duration, setDuration] = useState(1);
  const [pricePerMonth] = useState(500);

  const handleDurationChange = (amount) => {
    const newDuration = duration + amount;
    if (newDuration > 0) {
      setDuration(newDuration);
    }
  };

  const totalPrice = duration * pricePerMonth;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="bg2">
        <div className="bg3">
          <div style={{ textAlign: "center", position: "relative" }}>
            <img
              src="../style/img/Rehabserv/balanceco.jpg"
              className="pneumoban"
              alt="Pneumoban"
            />
           <h3 className="pneu1 text-white" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>
  <b class="text-white">Balance and Coordination</b>
</h3>
<p className="pneu2 text-white" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>
  <b class="text-white">
  Stabilize Your Future with Our Comprehensive Balance and Coordination
   Training Program, Designed to Enhance Your Physical Stability
    and Improve Your Everyday Functionality.
  </b>
</p>

          </div>
          <br />
          <div className="greenbg">
            <h3
              className="text-center text-white"
              style={{ fontWeight: "bold", fontFamily: "Poppins" }}
            >
              Package Highlights
            </h3>

            <div className="container">
              <div className="row">
                {[
                  {
                    imgSrc: "../style/img/resp/pneuicon2.png",
                    title: "Personalized Balance Assessment",
                    description:
                      "A thorough evaluation to identify your specific balance challenges and coordination needs, forming the basis of your customized training plan.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon2.png",
                    title: "Functional Balance Exercises",
                    description:
                      "Engaging activities focused on improving your balance in real-life situations, ensuring you can navigate your environment safely and confidently.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Core Stability Training",
                    description:
                      "Targeted exercises to strengthen your core muscles, providing a solid foundation for balance and coordination in daily activities.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Dynamic Balance Activities",
                    description:
                      "Incorporating movement into balance training, these activities challenge your stability while promoting functional mobility and coordination.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Proprioceptive Training",
                    description: "Exercises designed to enhance your body awareness and spatial orientation, vital for maintaining balance in various environments.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Coordination Skill Development",
                    description:
                      "Focused drills to improve hand-eye coordination, timing, and rhythm, essential for daily tasks and physical activities.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Safety and Fall Prevention Strategies",
                    description:
                      "Education on techniques to minimize fall risks, empowering you to engage confidently in daily life.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Group Balance Activities",
                    description:
                      "Opportunities for social interaction through group exercises that promote balance while fostering connections with peers.",
                  },
                ].map((item, index) => (
                  <div
                    className="col-sm-3 d-flex flex-column align-items-center text-center mb-4" // Added margin-bottom
                    key={index}
                  >
                    <div
                      className="blank d-flex flex-column justify-content-between"
                      style={{ height: "100%" }}
                    >
                      <img
                        src={item.imgSrc}
                        style={{
                          height: "60px",
                          display: "block",
                          margin: "40px auto",
                        }}
                        alt={item.title}
                      />
                      <h5 className="iconh">{item.title}</h5>
                      <p className="iconp">{item.description}</p>
                      <br />
                      <br />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div>
          <center>
            <h3
              style={{
                fontWeight: "800",
                fontFamily: "Poppins",
                fontSize: "30px",
              }}
            >
              Plan Purchase
            </h3>
            <h6
              style={{
                fontSize: "20px",
              }}
            >
              Choose Your Plan Duration
            </h6>
          </center>

          <div class="container">
            <center>
              <div
                class="greenbg priceboxgreen"
                style={{
                  borderRadius: "20px",
                  width: "750px",
                  height: "300px",
                }}
              >
                <br></br>
                <form
                  class="booking-form"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group11">
                    <label class="boxresd text-dark">Duration Selector:</label>
                    <div class="diaginput" style={{ position: "relative" }}>
                      <span
                        class="subtraction text-dark"
                        onClick={() => handleDurationChange(-1)}
                        style={{
                          position: "absolute",
                          left: 20,
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        -
                      </span>
                      <input
                        class="booktestdur"
                        name="duration"
                        value={`${duration} month${duration > 1 ? "s" : ""}`}
                        readOnly
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "0 40px",
                        }}
                      />
                      <span
                        class="addition text-dark  booktestadd"
                        onClick={() => handleDurationChange(1)}
                        style={{
                          position: "absolute",
                          right: 20,
                          bottom: "0px",
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        +
                      </span>
                    </div>
                  </div>
                  <div class="form-group11">
                    <label class="boxresd text-dark">Price:</label>
                    <div
                      class="diaginput"
                      style={{ position: "relative", marginLeft: "10px" }}
                    >
                      <input
                        class="booktestdur"
                        style={{ width: "300px" }}
                        type="number"
                        name="totalPrice"
                        value={totalPrice}
                        readOnly
                      />
                    </div>
                  </div>
                </form>
                <br></br>
                <center>
                  <button
                    class="purchasebutton"
                    style={{
                      fontWeight: "600",
                      backgroundColor: "#fff",
                      color: "#466E6C",
                      borderRadius: "30px",
                    }}
                  >
                    Purchase
                  </button>
                </center>
              </div>
            </center>
            <br></br>
          </div>
        </div>
      </div>
    </>
  );
}

export default Balanceco;
